import React, { useState } from 'react';
import { samplePrompts } from '../../data/samplePrompts';
import { PromptFlow } from './PromptFlow';
import { PromptDemo } from './PromptDemo';
import { PromptCard } from './PromptCard';
export function PromptExplainer() {
  const [active, setActive] = useState(0);
  return <section aria-label="What is a prompt" className="bg-ice text-obsidian" data-id="element-235" data-mp="3mkdfzmsnfz7t">
      <div className="mx-auto max-w-5xl px-5 py-14 sm:py-20" style={{
      paddingTop: "20px",
      paddingBottom: "28px"
    }} data-id="element-236" data-mp="37nmf193bufg3">
        <div className="text-center" data-id="element-237" data-mp="3cn8s9ij5nvow">
          <h2 className="font-display text-[28px] font-extrabold tracking-tight text-obsidian sm:text-4xl" data-id="element-238" data-mp="3coagkop6meok">What is a prompt?</h2>
          <p className="mx-auto mt-3 max-w-xl text-base text-graphite" data-id="element-239" data-mp="2yparxh1o5zse">
            It's a <span className="font-bold text-rescue-deep" data-id="element-240" data-mp="33mazjwe63alm">structured instruction</span> optimized for AI.
          </p>
        </div>

        <PromptFlow data-id="element-241" data-mp="11uo2bd3omjgp" />
        <PromptDemo data-id="element-242" data-mp="11v7lsy8zdfwu" />

        <div className="mx-auto mt-16 max-w-3xl" data-id="element-243" data-mp="11td0vjxplnsr">
          <h3 className="text-center font-display text-xl font-extrabold text-obsidian sm:text-2xl" data-id="element-244" data-mp="30hxr92s0tlje">Prompt samples</h3>
          <p className="mt-2 text-center text-sm text-graphite" data-id="element-245" data-mp="2wgvowd2t4td7">Fill in the brackets, copy, and open the prompt in your preferred AI tool.</p>

          <div role="tablist" aria-label="Sample prompts" className="-mx-5 mt-5 flex gap-2 overflow-x-auto px-5 pb-1 sm:mx-0 sm:flex-wrap sm:justify-center sm:overflow-visible sm:px-0" data-id="element-246" data-mp="3a78yskz9ei56">
            {samplePrompts.map((sp, i) => <button key={sp.n} role="tab" type="button" aria-selected={active === i} onClick={() => setActive(i)} className={`shrink-0 whitespace-nowrap rounded-full px-4 py-2 text-xs font-bold transition-colors duration-150 ease-out focus:outline-none focus-visible:ring-2 focus-visible:ring-rescue/50 ${active === i ? 'bg-obsidian text-ice' : 'border border-mist bg-white text-graphite hover:text-obsidian'}`} data-id="element-247" data-mp="2hl606768m24s" data-mpi={i}>
                #{sp.n} · {sp.title}
              </button>)}
          </div>

          <div className="mt-5" role="tabpanel" data-id="element-248" data-mp="1rp9fx1pljve">
            <PromptCard key={samplePrompts[active].n} prompt={samplePrompts[active]} data-id="element-249" data-mp="9t6dik69il1q" />
          </div>
        </div>
      </div>
    </section>;
}